import { NomenclatureBaseFindDto, type NomenclatureBaseFindInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-base-find.dto';
import { NomenclatureTypeEnum } from '@zaoblako/shared/modules/catalog/enums/nomenclature-type.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import type { NomenclatureGroupFindInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-group-find.dto';

import * as yup from 'yup';

/** Nomenclature item response body */
export interface NomenclatureItemFindInterface extends NomenclatureBaseFindInterface {
  /** Item type */
  type: NomenclatureTypeEnum;
  /** Item price */
  price: number;
  /** Group this item belongs to */
  group?: NomenclatureGroupFindInterface;
}

/** Nomenclature item response body - DTO schema */
export const NomenclatureItemFindDto = SerdeDtoClass.from<NomenclatureBaseFindInterface, NomenclatureItemFindInterface>(
  NomenclatureBaseFindDto,
  CatalogDtosKeysEnum.NOMENCLATURE_ITEM_FIND_DTO,
  {
    type: {
      label: 'Тип',
      serializer: yup
        .string()
        .oneOf(Object.values(NomenclatureTypeEnum)),
    },
    price: {
      label: 'Цена',
      serializer: yup.number(),
    },
    group: {
      optional: true,
      label: 'Группа',
      nested: CatalogDtosKeysEnum.NOMENCLATURE_GROUP_FIND_DTO,
      serializer: (_, nested) => nested,
    },
  },
);
